<template>
  <layouts-header v-if="!authStore.user"></layouts-header>
  <user-header v-if="authStore.user"></user-header>

  <breadcrumb :title="title" :text="text" :text1="text1" />

  <!-- Page Content -->
  <div class="content">
    <div class="container">
      <!-- Sort By -->
      <div class="row">
        <div class="col-lg-12">
          <div class="sortby-section">
            <div class="sorting-info">
              <div class="row d-flex align-items-center">
                <div class="col-xl-4 col-lg-3 col-sm-12 col-12"></div>
                <div class="col-xl-8 col-lg-9 col-sm-12 col-12">
                  <div class="sortby-filter-group">
                    <div class="grid-listview">
                      <ul class="nav">
                        <li>
                          <span>Chế độ xem</span>
                        </li>
                        <li>
                          <router-link to="/giai-dau">
                            <img
                              src="@/assets/img/icons/sort-01.svg"
                              alt="Icon"
                            />
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/list-giai-dau" class="active">
                            <img
                              src="@/assets/img/icons/sort-02.svg"
                              alt="Icon"
                            />
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sort By -->

      <div class="row">
        <!-- Featured Item -->
        <div class="col-lg-12" v-for="item in data" :key="item.id">
          <div class="featured-venues-item">
            <div class="listing-item listing-item-grid coach-listview">
              <div class="listing-img">
                <router-link to="/giai-dau/chi-tiet-giai-dau">
                  <img
                    :src="`${url + item?.photo?.url}`"
                    :alt="item?.photo?.documentId"
                  />
                </router-link>
              </div>
              <div class="listing-content">
                <div class="list-reviews near-review near-review-list">
                  <div class="d-flex align-items-center">
                    <span>Số người tham gia: {{ item.num_player }}</span>
                  </div>
                </div>
                <h3 class="listing-title">
                  <router-link to="/giai-dau/chi-tiet-giai-dau">{{
                    item.name
                  }}</router-link>
                </h3>
                <ul class="mb-2">
                  <li>
                    <span>
                      <i class="feather-map-pin me-2"></i
                      >{{ item?.arenas[0]?.name }}
                    </span>
                  </li>
                </ul>
                <div class="listing-details-group">
                  <p>{{ item.description }}</p>
                </div>
                <div class="avalbity-review avalbity-review-list">
                  <ul>
                    <li>
                      <div class="avalibity-date">
                        <span><i class="feather-calendar"></i></span>
                        <div class="avalibity-datecontent">
                          <div class="d-flex justify-content-start align-items-start gap-2">
                            <h6>Ngày bắt đầu: </h6>
                            <h5>{{ formatNewDate(item.date_start, "dd/MM/yyyy") }}</h5>
                          </div>
                          <div class="d-flex justify-content-start align-items-start gap-2">
                            <h6>Ngày kết thúc: </h6>
                            <h5>{{ formatNewDate(item.date_end, "dd/MM/yyyy") }}</h5>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ul class="profile-coache-list">
                    <li>
                      <router-link
                      :to="`/giai-dau/chi-tiet-giai-dau/${encodeURIComponent(
                          item?.name
                        )}`"
                        class="btn btn-primary w-100"
                        ><i class="feather-eye me-2"></i> Xem thêm</router-link
                      >
                    </li>
                    <li>
                      <router-link
                      :to="`/giai-dau/chi-tiet-giai-dau/${encodeURIComponent(
                          item?.name
                        )}`"
                        class="btn btn-secondary w-100"
                        ><i class="feather-calendar me-2"></i> Đăng
                        ký</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Featured Item -->

        <div class="col-12 text-center mt-3">
          <a href="javascript:;" class="btn btn-load"
            >Xem thêm giải đấu<img
              src="@/assets/img/icons/u_plus-square.svg"
              class="ms-2"
              alt="Icon"
          /></a>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Content -->

  <layout-footer></layout-footer>
</template>

<script >
import { GET_TOURNAMENT } from "@/graphql/operations/tournament.ts";
import { useQuery } from "@vue/apollo-composable";
import { ref, watch } from "vue";
import {formatDate, formatNewDate} from "@/utils/datetime";

import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    const authStore = useAuthStore();
    const url = process.env.VUE_APP_SERVER_URL;
    const { result: tournaments } = useQuery(GET_TOURNAMENT);
    const data = ref([]);

    watch(
      tournaments,
      () => {
        data.value = tournaments.value?.tournaments;
      },
      { deep: true }
    );

    return {
      authStore,
      url,
      data,
      title: "Giải đấu",
      text: "Trang chủ",
      text1: "Giải đấu",
      isSelected: false,
      Sort: ["Relevance", "Price"],
    };
  },
  methods: {
    formatNewDate,
    formatDate,
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>
